import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';

import { evBannerAdClick, evBannerAdView } from 'events/search';
import { trackEvent } from 'helpers/analytics';
import { track } from 'apis/amethyst';
import ImageLazyLoader from 'components/common/ImageLazyLoader';
import Tooltip from 'components/common/Tooltip';
import LandingPageLink from 'components/landing/LandingPageLink';
import { MoreInfo } from 'components/icons';

import css from 'styles/components/search/topBannerAd.scss';

const TopBannerAd = ({ searchTerm = '', slotDetails: { src, alt, link } }, { marketplace: { shortName, hasBannerAds } }) => {

  const handleClick = useCallback(() => {
    track(evBannerAdClick, { adLocation: 'HEADER', searchTerm });
    trackEvent('TE_BANNER_AD_CLICK', `searchTerm:${searchTerm}adLocation:HEADER`);
  }, [searchTerm]);

  useEffect(() => {
    track(evBannerAdView, { adLocation: 'HEADER', searchTerm });
    trackEvent('TE_BANNER_AD_VIEW', `searchTerm:${searchTerm}adLocation:HEADER`);
  }, [searchTerm]);

  if (!hasBannerAds) {
    return null;
  }

  const imgProps = { src, alt };
  return (
    <LandingPageLink url={link} className={css.innerWrapper} onClick={handleClick}>
      <ImageLazyLoader imgProps={imgProps} />
      <Tooltip
        content={`These are ads for products you'll find on ${shortName}.com. Clicking an ad will take you to the product's page.`}
        wrapperClassName={css.tooltipWrapper}
        tooltipClassName={css.tooltip}
        contentClassName={css.content}
        direction="down"
        tooltipId="topBannerAd"
      >
        Sponsored   <MoreInfo className={css.icon}/>
      </Tooltip>
    </LandingPageLink>
  );
};

TopBannerAd.contextTypes = {
  marketplace: PropTypes.object
};

export default TopBannerAd
;
